import { defineMessages } from 'react-intl';

const translations = {
  from: {
    title: {
      id: 'shipmentForm.from.title',
      defaultMessage: 'From',
      description: 'Title of the from address section in the shipment form',
    },
  },
  to: {
    title: {
      id: 'shipmentForm.to.title',
      defaultMessage: 'To',
      description: 'Title of the to address section in the shipment form',
    },
  },
  addressSelection: {
    title: {
      id: 'shipmentForm.addressSelection.title',
      defaultMessage: 'Select address',
      description: 'Title of the address selection drawer in the shipment form',
    },
  },
  formActions: {
    cancel: {
      id: 'formActions.cancel',
      defaultMessage: 'Cancel',
      description: 'label of the form action cancel',
    },
    save: {
      id: 'formActions.save',
      defaultMessage: 'Save',
      description: 'label of the form action save',
    },
  },
};

export default defineMessages(translations);
